import * as React from 'react';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon, SuccessIcon} from 'shells/action-box/action-icons';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {getSubtitle, getTitle} from 'shells/prepare-to-send/helpers';
import {PhoneMessagePreview} from 'shells/sms-campaigns/message-preview/phone-message-preview';
import {Body} from 'shells/typography/body';

import type {SmsDripSequenceFragment_from as Channel} from 'nutshell-graphql-types';

import {LinkActionBox, SmsFromActionBox} from '../../../editions/edition-action-boxes';

import {
    getIssueCount,
    getCharacterCountSubtitle,
    getHasCharacterCountError,
    getActionElement,
} from './helpers';

import styles from './check-required-items.module.css';

type Props = {
    onClose: () => void;
    isLoading: boolean;
    userFacingNoun: string;
    characterCount: number;
    editionContent: string;
    hasShortLink: boolean;
    optOutText: string | null | undefined;
    canAccessSetup: boolean;
    from: Channel | null | undefined;
};

export function CheckRequiredItems(props: Props) {
    const hasCharacterCountError = getHasCharacterCountError(props.characterCount);
    const issueCount = getIssueCount(props.characterCount, props.hasShortLink, props.from);

    return (
        <div className={styles.container}>
            <div className='pad-16'>
                <StackLegacy spacing={8}>
                    <Body size='xlarge' isBold={true}>
                        {getTitle(issueCount, props.userFacingNoun)}
                    </Body>
                    <Body>{getSubtitle(issueCount, props.userFacingNoun)}</Body>
                </StackLegacy>
                {props.isLoading ? (
                    <LoadingPage />
                ) : (
                    <div className='py-16 full-width'>
                        <StackLegacy spacing={16}>
                            <SmsFromActionBox
                                from={props.from}
                                canAccessSetup={props.canAccessSetup}
                            />
                            <ActionBox
                                title='Character count'
                                subtitle={getCharacterCountSubtitle(props.characterCount)}
                                icon={hasCharacterCountError ? <ErrorIcon /> : <SuccessIcon />}
                                actionElement={getActionElement(
                                    hasCharacterCountError,
                                    props.onClose
                                )}
                            />
                            {/* @ts-expect-error */}
                            <LinkActionBox hasShortLink={props.hasShortLink} />
                        </StackLegacy>
                    </div>
                )}
            </div>
            <div className={styles['right-container']}>
                <PhoneMessagePreview
                    message={props.editionContent}
                    optOutText={props.optOutText || undefined}
                />
            </div>
        </div>
    );
}
